import React from 'react';

import { observer } from 'mobx-react-lite';
import { FHRequestMessageType } from 'stores/fhrequest_message_store';
import useStores from 'hooks/useStores';
import { CursorType } from "utils/types"

type FHRequestMessageContextType = {
    sendMessage: (identity: string, request: string, content: string) => Promise<FHRequestMessageType>;
    //    sendAssistantMessage: (identity: string, request: string, content: string) => Promise<FHRequestMessageType>;

    // Fetch and get list by identity
    fetchListByRequest: (workKey: string, request: string, cursor?: CursorType) => Promise<FHRequestMessageType[]>;
    getListByRequest: (request: string, requestKey: string) => FHRequestMessageType[];
    items: FHRequestMessageType[];
    supportHelpRespond(workKey: string, request: string, message: string, clock: string): Promise<FHRequestMessageType>;
}

export const FHRequestMessageContext = React.createContext<FHRequestMessageContextType>({

    sendMessage: () => { throw 'Not Implemented' },
    //    sendAssistantMessage: () => { throw 'Not Implemented' },
    fetchListByRequest: () => { throw 'Not Implemented' },
    getListByRequest: () => { throw 'Not Implemented' },

    items: [] as FHRequestMessageType[],
    supportHelpRespond: () => { throw 'Not Implemented' },

});




export const FHRequestMessageProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { fhRequestMessageStore } = useStores();

    // const addItems = (newItems: FHRequestMessageType[] | FHRequestMessageType) => {
    //     // Autogenerated
    //     newItems = Array.isArray(newItems) ? newItems : [newItems];
    //     setFHRequestMessage([...items, ...newItems]);
    // };

    const sendMessage = async (identity: string,
        request: string,
        content: string) => {
            const response = await fhRequestMessageStore.sendMessage(identity, request, content);
        return response;
    };

    // const sendAssistantMessage = async (identity: string,
    //     request: string,
    //     content: string) => {
    //     const response = await fhRequestMessageStore.sendAssistantMessage(identity, request, content);
    //     return response;
    // };

    const fetchListByRequest = async (identity: string, request: string, cursor?: CursorType) => {
        const response = await fhRequestMessageStore
            .fetchListByRequest(identity, request, cursor);
        return response;
    };

    const getListByRequest = (request: string, request_key: string) => {
        console.log("Searching for request: ", request, request_key);
        return fhRequestMessageStore
            .items
            .filter((item: FHRequestMessageType) => item.request === request || item.request === request_key)
            .sort((a, b) => a.date_created > b.date_created ? 1 : -1);
    };

    const supportHelpRespond = async (workKey: string, request: string, message: string, clock: string) => {
        const response = await fhRequestMessageStore.supportHelpRespond(workKey, request, message, clock);
        return response;
    };

    const data = {
        sendMessage,
        // sendAssistantMessage,
        fetchListByRequest,
        getListByRequest,
        items: fhRequestMessageStore.items,
        supportHelpRespond,
    };

    return (
        <FHRequestMessageContext.Provider value={data}>{ children }</FHRequestMessageContext.Provider>
    );

});
